import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-trade-success",
  "use": "icon-trade-success-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol viewBox=\"0 0 36 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-trade-success\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 0H27V3H30V6H33V9H36V27H33V30H30V33H27V36H9V33H6V30H3V27H0V9H3V6H6V3H9V0ZM9 17.3033L11.1213 15.182L16.4246 20.4852L24.9098 11.9999L27.0312 14.1212L18.5459 22.6065L18.5459 22.6066L16.4246 24.7279L16.4246 24.7278L14.3032 22.6065L9 17.3033Z\" fill=\"#20F3B1\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol